<template>
  <v-container class="messages pa-0" fluid>
    <v-alert tile dense :value="showMessage(1)" color="color-new-link-blue color-white--text" icon="fas fa-user-lock" class="mb-0">
      <multiple-debts></multiple-debts>
    </v-alert>
    <v-alert tile dark :value="showMessage(2)" color="color-new-dark-grey" icon="fas fa-info-circle" class="mb-0">
      <v-row no-gutters align="center">
        <span>{{ $t('dm-text-1') }}</span>
      </v-row>
    </v-alert>
    <v-alert tile dark :value="showOPMessage" color="color-new-dark-grey" icon="fas fa-info-circle" class="mb-0">
      <v-row class="white--text px-3" align="center" justify="start">
        <span class="mr-3">{{ $t('dm-text-2') }}</span>
        <v-btn tile small color="success" @click.stop="ibanDialog = true">{{ $t('dm-text-3') }}</v-btn>
        <v-dialog v-model="ibanDialog" width="860px" max-width="90%">
          <add-iban-dialog @close="ibanDialog = false"></add-iban-dialog>
        </v-dialog>
      </v-row>
    </v-alert>
    <v-alert tile :value="showReconciliationMessage" color="color-red" icon="fas fa-envelope" class="mb-0">
      <v-row class="white--text px-3" align="center" justify="space-between" v-if="showReconciliationMessage">
        <span>{{ $t('dm-text-4') }}</span>
        <v-btn dark :block="this.$vuetify.breakpoint.smAndDown" :class="{ 'mt-3' : this.$vuetify.breakpoint.smAndDown }" tile color="black" @click="startReconciliationProcess">{{ $t('dm-text-5') }}</v-btn>
        <v-dialog persistent
                  v-model="showReconciliationDialog"
                  :fullscreen="dialogSettings.fullscreen"
                  :scrollable="dialogSettings.scrollable"
                  :hide-overlay="dialogSettings.hideoverlay"
                  :transition="dialogSettings.transition"
                  :width="dialogSettings.width"
                  :max-width="dialogSettings.maxwidth"
                  content-class="full-screen-dialog">
          <reconciliation-dialog :initialSubPoena="subpoena" @close="showReconciliationDialog = false"></reconciliation-dialog>
        </v-dialog>
      </v-row>
    </v-alert>
    <v-dialog v-model="showReconciliationCompleteDialog"
              :fullscreen="dialogSettings.fullscreen"
              :scrollable="dialogSettings.scrollable"
              :hide-overlay="dialogSettings.hideoverlay"
              :transition="dialogSettings.transition"
              :width="dialogSettings.width"
              :max-width="dialogSettings.maxwidth"
              content-class="full-screen-dialog">
      <reconciliation-complete-dialog @close="showReconciliationCompleteDialog = false"></reconciliation-complete-dialog>
    </v-dialog>
    <v-dialog v-model="showVerdictSentDialog"
              :fullscreen="dialogSettings.fullscreen"
              :scrollable="dialogSettings.scrollable"
              :hide-overlay="dialogSettings.hideoverlay"
              :transition="dialogSettings.transition"
              :width="dialogSettings.width"
              :max-width="dialogSettings.maxwidth"
              content-class="full-screen-dialog">
      <verdict-sent-dialog @close="showVerdictSentDialog = false"></verdict-sent-dialog>
    </v-dialog>
    <v-dialog v-model="showPaymentPlanCreatedDialog"
              :fullscreen="dialogSettings.fullscreen"
              :scrollable="dialogSettings.scrollable"
              :hide-overlay="dialogSettings.hideoverlay"
              :transition="dialogSettings.transition"
              :width="dialogSettings.width"
              :max-width="dialogSettings.maxwidth"
              content-class="full-screen-dialog">
      <v-card class="align-center">
        <shared-paymentplan-created-dialog @close="showPaymentPlanCreatedDialog = false"></shared-paymentplan-created-dialog>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showPaymentPendingDialog"
              :fullscreen="dialogSettings.fullscreen"
              :scrollable="dialogSettings.scrollable"
              :hide-overlay="dialogSettings.hideoverlay"
              :transition="dialogSettings.transition"
              :width="dialogSettings.width"
              :max-width="dialogSettings.maxwidth"
              content-class="full-screen-dialog">
      <v-card class="align-center">
        <v-container class="pb-0">
          <v-row justify="end">
            <v-col class="shrink">
              <v-btn color="color-grey" depressed right text small @click="showPaymentPendingDialog = false">
                <v-icon class="mr-3">fa-times</v-icon>
                <span>{{ $t('close') }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="showPaymentCompleteDialog === true">
          <v-row justify="center">
            <div class="pa-3">
              <v-icon :size="175" color="color-new-title-green">
                far fa-check-circle
              </v-icon>
            </div>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h2 class="text-h2 mt-2 mb-8 text-center">
                {{ $t('payment-complete-header') }}
              </h2>
              <p class="mb-0 text-center">{{ $t('payment-complete-text') }}</p>
            </v-col>
          </v-row>
          <shared-customer-feedback :orderNr="paymentDebtNr" :type="2" @close="showPaymentPendingDialog = false"></shared-customer-feedback>
          <v-row justify="center">
            <div class="pa-3">
              <v-btn tile outlined color="color-new-link-blue" class="wide-button" @click="showPaymentPendingDialog = false">
                <span>{{ $t('closeWindow') }}</span>
              </v-btn>
            </div>
          </v-row>
        </v-container>
        <v-container v-else>
          <v-row>
            <v-col cols="12">
              <h2 class="text-h2 mt-0 text-center">
                {{ $t('payment-pending-header') }}
              </h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-progress-circular :size="75" color="primary" indeterminate />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" :class="{ 'text-center' : this.$vuetify.breakpoint.mdAndUp }">
              <p class="mb-0 mt-2 font-weight-bold">{{ $t('payment-pending-text-1') }}</p>
              <p class="font-weight-bold">{{ $t('payment-pending-text-2') }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" :class="{ 'text-center' : this.$vuetify.breakpoint.mdAndUp }">
              <p class="mb-0">{{ $t('payment-pending-text-3') }}</p>
              <p>{{ $t('payment-pending-text-4') }}</p>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-snackbar :timeout="30000"
                color=color-new-dark-grey
                v-model="showVerdictAvailableMessage"
                style="z-index: 1000000;">
      <span>{{ $t('dm-text-6') }}</span>
      <template v-if="verdictRecentAvailableDebts.length > 1">
        <a class="white--text font-weight-bold ml-1" :to="'/debt/' + debt.orderNr" v-for="debt in verdictRecentAvailableDebts" :key="debt.orderNr" data-matomo-mask>
          {{ debt.orderNr }}
        </a>
      </template>
      <template v-if="verdictRecentAvailableDebts.length === 1">
        <a class="white--text font-weight-bold ml-1" data-matomo-mask>
          {{ verdictRecentAvailableDebts[0].orderNr }}
        </a>
      </template>
      <br />
      <span>{{ $t('dm-text-7') }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn icon dark text @click="showVerdictAvailableMessage = false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import LoginWithSocSec from './LoginWithSocSec.vue'
  import AddIbanDialog from './AddIbanDialog.vue'
  import ReconciliationDialog from '@/components/Reconciliation/Reconciliation.vue'
  import ReconciliationCompleteDialog from '@/components/Reconciliation/ReconciliationComplete.vue'
  import VerdictSentDialog from '@/components/Verdict/VerdictSentDialog.vue'

  export default {
    data: function () {
      return {
        messages: [
          { type: 1, show: false, userHide: false, name: 'MultipleDebts' },
          { type: 2, show: false, userHide: false, name: 'PaymentPending' }
        ],
        pollingActive: false,
        ibanDialog: false,
        showPaymentPendingDialog: false,
        showPaymentCompleteDialog: false
      }
    },
    methods: {
      showMessage(type) {
        var message = this.messages.filter(message => message.type === type)
        if (message != null && message.length === 1) {
          return message[0].show && !message[0].userHide
        } else {
          return false
        }
      },
      pollForPaymentSuccess() {
        this.$store.dispatch('refreshPendingPayment')
      },
      hideMessages() {
        this.messages.forEach((message) => {
          message.show = false
          message.userHide = false
        })
      },
      paymentPendingChanges: function (val, oldVal = false) {
        var message = this.messages.filter(message => message.type === 2)
        message[0].show = val

        if (val && !this.showReconciliationDialog) {
          this.showPaymentPendingDialog = true
        }

        if (val && (!oldVal || oldVal == null)) {
          this.pollingActive = setInterval(function () {
            this.pollForPaymentSuccess()
          }.bind(this), 15000)
        } else if (oldVal && !val) {
          var type = 'payment'
          if (this.showReconciliationDialog) {
            type = 'reconciliation'
            this.$matomo && this.$matomo.trackEvent("Action", "Make Settlement", "Settlement Payment Completed")
            this.$matomo && this.$matomo.trackEvent("Action", "Make Settlement", "Settlement Succesful")
          }

          clearInterval(this.pollingActive)

          if (this.showPaymentPendingDialog === true) {
            this.showPaymentCompleteDialog = true
          } else {
            this.$store.commit('setMessage', { type: 'primary', text: 'paymentConfirmed', translate: true, clickToDismiss: true })
          }

          this.$store.dispatch('silentInitialize', { type: type })
          this.$matomo && this.$matomo.trackEvent("Payment", "Payment", "Payment received")
        }
      },
      startReconciliationProcess() {
        this.showReconciliationDialog = true
        this.$matomo && this.$matomo.trackEvent("Action", "Make Settlement", "Settlement Notification")
      }
    },
    mounted: function () {
      var showMulti = (this.auth_type === 2 && !this.socSecVerified && this.debtor.hasMultipleDebts && this.debtor.isPerson)
      var multiMessage = this.messages.filter(message => message.type === 1)
      multiMessage[0].show = showMulti
      this.paymentPendingChanges(this.paymentPending)
    },
    computed: {
      ...mapGetters({
        debtor: 'debtor',
        reconciliation: 'reconciliation',
        auth_type: 'auth_type',
        socSecVerified: 'socSecVerified',
        paymentPending: 'paymentPending',
        authenticated: 'authenticated',
        verdictRecentAvailableDebts: 'verdictRecentAvailableDebts',
        seenVerdictAvailableMessage: 'seenVerdictAvailableMessage',
        paymentType: 'paymentType',
        paymentDebtNr: 'paymentDebtNr'
      }),
      showReconciliationDialog: {
        get: function () {
          return this.$store.getters.showReconciliationDialog
        },
        set: function (val) {
          this.$store.commit('setShowReconciliationDialog', val)
        }
      },
      showReconciliationCompleteDialog: {
        get: function () {
          return this.$store.getters.showReconciliationCompleteDialog
        },
        set: function (val) {
          this.$store.commit('setShowReconciliationCompleteDialog', val)
        }
      },
      showVerdictSentDialog: {
        get: function () {
          return this.$store.getters.showVerdictSentDialog
        },
        set: function (val) {
          this.$store.commit('setShowVerdictSentDialog', val)
        }
      },
      showVerdictAvailableMessage: {
        get: function () {
          return !this.seenVerdictAvailableMessage && this.verdictRecentAvailableDebts.length > 0
        },
        set: function (val) {
          if (val === false) {
            this.$store.commit('setSeenVerdictAvailableMessage', true)
          }
        }
      },
      showPaymentPlanCreatedDialog: {
        get: function () {
          return this.$store.getters.showPaymentPlanCreatedDialog
        },
        set: function (val) {
          this.$store.commit('setShowPaymentPlanCreatedDialog', val)
        }
      },
      dialogSettings() {
        return {
          fullscreen: this.$vuetify.breakpoint.smAndDown,
          scrollable: false, // this.$vuetify.breakpoint.smAndDown,
          hideoverlay: this.$vuetify.breakpoint.smAndDown,
          transition: this.$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition',
          width: this.$vuetify.breakpoint.smAndDown ? 'auto' : '1024px',
          maxwidth: this.$vuetify.breakpoint.smAndDown ? 'none' : '90%'
        }
      },
      hasMessages() {
        var hasMessages = this.messages.some(function (k) {
          return k.show && !k.userHide
        })
        return hasMessages
      },
      showOPMessage() {
        return this.debtor.hasOverpayment === true
      },
      showReconciliationMessage() {
        return this.reconciliation.available === true
      },
      subpoena() {
        return this.reconciliation.available === true ? this.reconciliation.subpoenas[0] : null
      }
    },
    watch: {
      authenticated: function (val, oldVal) {
        if (oldVal && !val) {
          clearInterval(this.pollingActive)
          this.pollingActive = false
          this.hideMessages()
        }
      },
      paymentPending: function (val, oldVal) {
        this.paymentPendingChanges(val, oldVal)
      },
      showPaymentPendingDialog: function (val, oldVal) {
        if (oldVal && !val) {
          this.showPaymentCompleteDialog = false
        }
      }
    },
    components: {
      'multiple-debts': LoginWithSocSec,
      'add-iban-dialog': AddIbanDialog,
      'reconciliation-dialog': ReconciliationDialog,
      'reconciliation-complete-dialog': ReconciliationCompleteDialog,
      'verdict-sent-dialog': VerdictSentDialog
    }
  }
</script>

<style>
  .v-alert .v-alert__icon.v-icon {
    color: #fff;
    font-size: 1.60em;
  }
</style>

<i18n>
  {
  "fi": {
  "dm-text-1": "Sinulla on maksusuorituksia, jotka eivät vielä näy Oma B2 Impact -palvelussa. Tiedot päivittyvät hetken kuluttua.",
  "dm-text-2": "Tähän velkaan on tehty ylisuoritus. Ilmoita maksutiedot palautusta varten ",
  "dm-text-3": "Paina tästä",
  "dm-text-4": "Huom! Velkasi käsittely on edennyt käräjäoikeuteen. Haastehakemuksen peruuttaminen edellyttää sinulta toimenpiteitä.",
  "dm-text-5": "Aloita tästä!",
  "dm-text-6": "Seuraaviin asioisihi on annettu ratkaisu käräjäoikeudessa: ",
  "dm-text-7": "Saat ratkaisun kopion itsellesi kyseisen velan sivulta.",
  "payment-pending-header": "Maksua käsitellään, pieni hetki",
  "payment-pending-text-1": "Odotamme vahvistusta tekemästäsi maksusuorituksesta.",
  "payment-pending-text-2": "Saamme tiedon maksusta noin 30 sekunnin sisällä.",
  "payment-pending-text-3": "Jos tämä viesti jää näkyviin pidemmäksi aikaa, maksutapahtuma on epäonnistunut.",
  "payment-pending-text-4": "Ota siinä tilanteessa yhteyttä asiakaspalveluumme.",
  "payment-complete-header": "Kiitos maksusta!",
  "payment-complete-text": "Olemme vastaanottaneet maksusuorituksesi."
  },
  "se": {
  "dm-text-1": "Betalningen lyckades. Vänta en stund på att betalningen registreras.",
  "dm-text-2": "En överbetalning har gjorts för denna skuld. Vänligen ange dina betalningsuppgifter för återbetalning ",
  "dm-text-3": "Tryck här",
  "dm-text-4": "OBS! Handläggningen av din skuld är nu hos tingsrätten. En annullering av stämningsansökan kräver åtgärder av dig.",
  "dm-text-5": "Börja här!",
  "dm-text-6": "Tingsrätten har gett ett beslut angående dina ärenden: ",
  "dm-text-7": "Du får en kopia av beslutet till dig själv från skuldens egen sida.",
  "payment-pending-header": "Betalningen behandlas, vänligen vänta en stund.",
  "payment-pending-text-1": "Vi väntar på bekräftelse om din betalning.",
  "payment-pending-text-2": "Vi får information om betalningen inom cirka 30 sekunder.",
  "payment-pending-text-3": "Om detta meddelande visas i flera minuter har betalningstransaktionen avbrutits.",
  "payment-pending-text-4": "I detta fall vänligen kontakta vår kundtjänst.",
  "payment-complete-header": "Tack för betalningen!",
  "payment-complete-text": "Betalningstransaktionen lyckades"
  },
  "en": {
  "dm-text-1": "The payment was successful. Please wait for the payment to be registered.",
  "dm-text-2": "An overpayment has been made for this debt. Please provide your payment details for the refund ",
  "dm-text-3": "Click here",
  "dm-text-4": "Please note! The handling of your debt has been transferred to the District Court. Cancelling the summons application requires certain actions from you.",
  "dm-text-5": "Continue!",
  "dm-text-6": "District court has given its verdict regarding your cases: ",
  "dm-text-7": "You can get a copy of the verdict to yourself from each debts own page.",
  "payment-pending-header": "Your payment is being processed, please wait.",
  "payment-pending-text-1": "We are waiting for a confirmation of your payment.",
  "payment-pending-text-2": "This should only take about 30 seconds.",
  "payment-pending-text-3": "If this notification remains visible for several minutes, it means that the transaction was interrupted.",
  "payment-pending-text-4": "In that case, please contact our customer service.",
  "payment-complete-header": "Thank you for your payment!",
  "payment-complete-text": "The transaction was successful."
  }
  }
</i18n>

<style>
  .messages .v-alert__icon {
    align-self: center;
  }
</style>
